import React, { useEffect, useState } from 'react'

interface TransitPreviewSectionProps {
  columnId: string
  headingLabel: string
  initialSectionState?: boolean
  delayedOpenSection?: boolean
}

function TransitPreviewSection({
  columnId,
  headingLabel,
  children,
  initialSectionState,
  delayedOpenSection,
}: React.PropsWithChildren<TransitPreviewSectionProps>) {
  const [isSectionOpen, toggleSection] = useState<boolean>(initialSectionState ?? true)

  useEffect(() => {
    if (delayedOpenSection === true) {
      toggleSection(true)
    }
  }, [delayedOpenSection])

  return (
    <section className="pb-3">
      <h3>
        <button
          type="button"
          className={
            `collapsible-column__heading w-100 d-flex justify-content-between ${isSectionOpen ? 'mb-2' : 'mb-0'}`
          }
          data-bs-toggle="collapse"
          data-bs-target={`#${columnId}`}
          aria-expanded={isSectionOpen}
          aria-controls={columnId}
          onClick={() => toggleSection(!isSectionOpen)}
        >
          <span className="collapsible-column__heading-label mb-2">{headingLabel}</span>
          <i className={`mx-2 fa ${isSectionOpen ? 'fa-chevron-up' : 'fa-chevron-down'}`} />
        </button>
      </h3>
      <div className={`collapse ${isSectionOpen ? 'show' : ''}`} id={columnId}>
        <div className="d-flex justify-content-around m-0">
          {isSectionOpen && children}
        </div>
      </div>
    </section>
  )
}

TransitPreviewSection.defaultProps = {
  initialSectionState: undefined,
  delayedOpenSection: undefined,
}

export default TransitPreviewSection
